import { defineMessages } from 'react-intl'

const scope = `procurify.accounts-payable.feature-sets.ReconciliationMatchView.components.ReconciliationFooter`

export default defineMessages({
  ccItemsSelected: {
    id: `${scope}.ccItemsSelected`,
    defaultMessage: '{count} Procurify item(s) selected',
  },
  matchedWith: {
    id: `${scope}.matchedWith`,
    defaultMessage: 'Matched with',
  },
  statementItemsSelected: {
    id: `${scope}.statementItemsSelected`,
    defaultMessage: '{count} credit card statement item(s) selected',
  },
  totalLabel: {
    id: `${scope}.totalLabel`,
    defaultMessage: 'Total',
  },
  varianceLabel: {
    id: `${scope}.varianceLabel`,
    defaultMessage: 'Variance',
  },
  deselectAllButton: {
    id: `${scope}.deselectAllButton`,
    defaultMessage: 'Deselect all',
  },
  matchButton: {
    id: `${scope}.matchButton`,
    defaultMessage: 'Match',
  },
  endingBalanceLabel: {
    id: `${scope}.endingBalanceLabel`,
    defaultMessage: 'Ending balance',
  },
  clearedBalanceLabel: {
    id: `${scope}.clearedBalanceLabel`,
    defaultMessage: 'Cleared balance',
  },
  matchedItemsLink: {
    id: `${scope}.matchedItemsLink`,
    defaultMessage: 'Matched items(s)',
  },
  submitButton: {
    id: `${scope}.submitButton`,
    defaultMessage: 'Submit',
  },
})
